define('views/components/metrik_user/metrik_users',['require','views/base/collection_view','views/components/metrik_user/metrik_user_list','text!templates/base/collection.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/metrik_user/metrik_user_list');

    var temp = require("text!templates/base/collection.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container metrik-user-grid-container',

        
        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});

